export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/d9f26165e744ef064b81249371ce3c44.svg";